import React, { useState } from "react";
import "./erxViewHeader.scss";
import Popover from "react-popover";
import PrefilledRxDetailsDropdown from "./PrefilledRxDetailsDropdown";
import C2CCustomPopup from "../../common/Popups/C2CCustomPopup";
import settingIcon from "../../../assets/settings_gear_icon.svg";
import left_arrow from "../../../assets/buttonArrow.svg";
import PDView from "../ERXMain/PDView";
import editIcon from "../../../assets/edit-icon1.svg";
import infoIcon from "../../../assets/info.png";
import {
  SAVE_TEMPLATE_HOVER_TEXT,
  SELECTED_TAB_LIST,
  SELECTION_LIST_TITLES,
} from "../ERXConstants/constants";
import { Spinner } from "react-bootstrap";

const ERXViewHeader = (props) => {
  const {
    showPrescriptionHome,
    templatesList,
    pastConsultationsList,
    addRecordList,
    selectedTemplate,
    updatedGender,
    allowedObstetricDetailsSpecializations,
    doctorSpecialization,
    previewLoader,
    handleShowPrescriptionsHome,
    handleClose,
    handleSelectedTemplate,
    handleSelectedPastConsultation,
    handleSelectRecord,
    handleSetDefaultTemplate,
    patientDetails,
    handleSaveAndPreview,
    patientPhoneNo,
    displaySaveTemplate,
    setSavePrescriptionTemplate,
    savePrescriptionTemplate,
    handleDeleteTemplateAPICall,
    getTemplatesApi,
    patientDetailsName,
    handleRemoveTemplateName,
    isPatientDetailsPopupOpen,
    setPatientDetailsPopupOpen,
    handleClosePopup,
    handleTemplateCancel,
  } = props;

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showOnHover, setShowOnHover] = useState(false);

  const handlePatientDetailsClick = () => {
    setPatientDetailsPopupOpen(true);
  };
  const handleImageClick = () => {
    setPopupOpen(true);
  };

  const handleMouseOver = () => {
    setShowOnHover(true);
  };

  const handleMouseOut = () => {
    setShowOnHover(false);
  };

  // Function to close the popup
  const handleSettingClosePopup = () => {
    setPopupOpen(false);
  };

  const handelSaveTemplate = () => {
    setSavePrescriptionTemplate(true);
  };

  const displaySaveAndPreviewPrescription = () => {
    return (
      <div
        className={
          "erx-view-container-save-preview-prescription " +
          (previewLoader ? "erx-preview-btn-cursor" : "")
        }
        onClick={() => (previewLoader ? "" : handleSaveAndPreview("edited"))}
      >
        <div>Preview</div>
        {previewLoader && (
          <div>
            <Spinner animation="border" className="erx-preview-spinner" />
          </div>
        )}
      </div>
    );
  };
  const displayERXHeader = () => {
    return (
      <div
        className="erx-view-container-header-cont"
        style={{
          height: !showPrescriptionHome ? "" : "77px",
        }}
      >
        <>
          <div className="erx-view-container-header">
            {window.innerWidth > 767 ? (
              <>
                <img
                  src={left_arrow}
                  alt=""
                  onClick={handleClose}
                  className="erx-right-arrow-styles"
                />
                <div className="erx-patient-edit-details">
                  <div>
                    <div
                      className={
                        "erx-patient-name " +
                        (patientDetailsName?.length > 20
                          ? "erx-patient-name-break"
                          : "")
                      }
                    >
                      {patientDetails?.patient_name}
                    </div>
                    <div className="erx-patient-phoneno">{patientPhoneNo}</div>
                  </div>
                  <img
                    className="patient-details-edit-icon"
                    src={editIcon}
                    alt="edit"
                    onClick={handlePatientDetailsClick}
                  />
                </div>
                <div className="erx-container-tab-btn-wrapper">
                  <div
                    className={
                      "erx-view-container-header-value " +
                      (showPrescriptionHome === SELECTED_TAB_LIST.HOME
                        ? "erx-view-container-header-selected"
                        : "")
                    }
                    onClick={() =>
                      handleShowPrescriptionsHome(SELECTED_TAB_LIST.HOME)
                    }
                  >
                    Home
                  </div>
                  <div
                    className={
                      "erx-view-container-header-value " +
                      (showPrescriptionHome === SELECTED_TAB_LIST.FILES
                        ? "erx-view-container-header-selected"
                        : "")
                    }
                    onClick={() =>
                      handleShowPrescriptionsHome(SELECTED_TAB_LIST.FILES)
                    }
                  >
                    Files
                  </div>
                  <div
                    className={
                      "erx-view-container-header-value " +
                      (showPrescriptionHome === SELECTED_TAB_LIST.VACCINE_CHART
                        ? "erx-view-container-header-selected"
                        : "")
                    }
                    onClick={() =>
                      handleShowPrescriptionsHome(
                        SELECTED_TAB_LIST.VACCINE_CHART
                      )
                    }
                  >
                    Vaccine Chart
                  </div>
                  <div
                    className={
                      "erx-view-container-header-value " +
                      (showPrescriptionHome === SELECTED_TAB_LIST.GROWTH_CHART
                        ? "erx-view-container-header-selected"
                        : "")
                    }
                    onClick={() =>
                      handleShowPrescriptionsHome(
                        SELECTED_TAB_LIST.GROWTH_CHART
                      )
                    }
                  >
                    Growth Chart
                  </div>
                  <div
                    className={
                      "erx-view-container-header-value " +
                      (showPrescriptionHome === SELECTED_TAB_LIST.PRESCRIPTION
                        ? "erx-view-container-header-selected"
                        : "")
                    }
                    onClick={() =>
                      handleShowPrescriptionsHome(
                        SELECTED_TAB_LIST.PRESCRIPTION
                      )
                    }
                  >
                    Prescription
                  </div>
                </div>
              </>
            ) : (
              <div
                className="erx-header-mobile-view"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <img
                    src={left_arrow}
                    alt=""
                    onClick={handleClose}
                    className="erx-right-arrow-styles "
                  />
                  <div className="erx-patient-edit-details">
                    <div>
                      <div
                        className={
                          "erx-patient-name " +
                          (patientDetailsName?.length > 20
                            ? "erx-patient-name-break"
                            : "")
                        }
                      >
                        {patientDetailsName}
                      </div>
                      <div className="erx-patient-phoneno">
                        {patientPhoneNo}
                      </div>
                    </div>
                    <img
                      className="patient-details-edit-icon"
                      src={editIcon}
                      alt="edit"
                      onClick={handlePatientDetailsClick}
                    />
                  </div>
                </div>
                <img
                  src={settingIcon}
                  alt="setting"
                  onClick={handleImageClick}
                  style={{ marginRight: 10 }}
                />
              </div>
            )}
          </div>
          {window.innerWidth > 767 && (
            <>
              <img
                src={settingIcon}
                alt="setting"
                onClick={handleImageClick}
                style={{ marginRight: 10 }}
              />
              {displayPrefilledRxDetails()}
              <div
                className="erx-view-container-save-preview-prescription-template"
                onClick={handelSaveTemplate}
              >
                Save Template
              </div>
              {displaySaveAndPreviewPrescription()}
            </>
          )}
        </>
      </div>
    );
  };
  const displayERXHeaderMobileView = () => {
    return (
      <div>
        <div
          className="d-flex ai-center"
          style={{ padding: "0 15px", overflowX: "scroll" }}
        >
          <div
            className={
              "erx-view-container-mobile-view-header-value " +
              (showPrescriptionHome === SELECTED_TAB_LIST.HOME
                ? "erx-view-container-mobile-view-header-selected"
                : "")
            }
            onClick={() => handleShowPrescriptionsHome(SELECTED_TAB_LIST.HOME)}
          >
            Home
          </div>
          <div
            className={
              "erx-view-container-mobile-view-header-value " +
              (showPrescriptionHome === SELECTED_TAB_LIST.FILES
                ? "erx-view-container-mobile-view-header-selected"
                : "")
            }
            onClick={() => handleShowPrescriptionsHome(SELECTED_TAB_LIST.FILES)}
          >
            File
          </div>
          <div
            className={
              "erx-view-container-mobile-view-header-value " +
              (showPrescriptionHome === SELECTED_TAB_LIST.VACCINE_CHART
                ? "erx-view-container-mobile-view-header-selected"
                : "")
            }
            onClick={() =>
              handleShowPrescriptionsHome(SELECTED_TAB_LIST.VACCINE_CHART)
            }
          >
            Vaccine Chart
          </div>
          <div
            className={
              "erx-view-container-mobile-view-header-value " +
              (showPrescriptionHome === SELECTED_TAB_LIST.GROWTH_CHART
                ? "erx-view-container-mobile-view-header-selected"
                : "")
            }
            onClick={() =>
              handleShowPrescriptionsHome(SELECTED_TAB_LIST.GROWTH_CHART)
            }
          >
            Growth Chart
          </div>
          <div
            className={
              "erx-view-container-mobile-view-header-value " +
              (showPrescriptionHome === SELECTED_TAB_LIST.PRESCRIPTION
                ? "erx-view-container-mobile-view-header-selected"
                : "")
            }
            onClick={() =>
              handleShowPrescriptionsHome(SELECTED_TAB_LIST.PRESCRIPTION)
            }
          >
            Prescription
          </div>
        </div>
        {showPrescriptionHome === SELECTED_TAB_LIST.HOME && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {displayPrefilledRxDetails()}
          </div>
        )}
        {!showPrescriptionHome && (
          <div className="prefilled-rx-details-dropdown-mobile-view">
            <img src={settingIcon} alt="setting" onClick={handleImageClick} />
            {displaySaveAndPreviewPrescription()}
          </div>
        )}
      </div>
    );
  };

  const displayPrefilledRxDetails = () => {
    return (
      <PrefilledRxDetailsDropdown
        templatesList={templatesList}
        pastConsultationsList={pastConsultationsList}
        selectedTemplate={selectedTemplate}
        handleSelectedTemplate={handleSelectedTemplate}
        handleSelectedPastConsultation={handleSelectedPastConsultation}
        handleSetDefaultTemplate={handleSetDefaultTemplate}
        handleDeleteTemplateAPICall={handleDeleteTemplateAPICall}
        getTemplatesApi={getTemplatesApi}
        handleRemoveTemplateName={handleRemoveTemplateName}
      />
    );
  };
  const displayAddSetting = () => {
    let filteredAddRecordList = addRecordList.filter((ele) =>
      ele.value === SELECTION_LIST_TITLES.OBSTETRIC_CALCULATOR
        ? updatedGender?.toLowerCase() === "female" &&
          allowedObstetricDetailsSpecializations.includes(doctorSpecialization)
        : true
    );
    return (
      <>
        {filteredAddRecordList.map((item) => (
          <div
            key={item.id}
            className="add-records-dropdown-options"
            style={{
              cursor: item.label === "Patient Details" ? "not-allowed" : "",
              display: "flex",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            <label
              className={`add-record-setting-tick hover-pointer cursor-pointer ${
                item.selected ? "selected" : "unselected"
              }`}
              style={{
                backgroundColor: item.selected ? "#17BAE0" : "",
              }}
            >
              <input
                type="checkbox"
                checked={item.selected}
                onChange={() =>
                  item.label !== "Patient Details"
                    ? handleSelectRecord(item)
                    : ""
                }
                style={{ display: "none" }}
              />
              <span>
                {item.selected ? (
                  <i
                    className="fa fa-check facheck cursor-pointer"
                    style={{ fontSize: 13 }}
                  ></i>
                ) : null}
              </span>
            </label>
            <div className="add-records-settings">{item.label}</div>
          </div>
        ))}
      </>
    );
  };

  const renderPopover = () => {
    return (
      <Popover
        isOpen={showOnHover}
        preferPlace={`end`}
        place={null}
        className="save-template-view-hover-text"
        body={SAVE_TEMPLATE_HOVER_TEXT}
      >
        <img
          src={infoIcon}
          alt=""
          style={{
            cursor: "pointer",
            marginRight: "10px",
            height: 15,
            width: 15,
          }}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        />
      </Popover>
    );
  };
  // <===
  return (
    <div className="erx-view-header">
      {displayERXHeader()}
      {window.innerWidth < 767 && displayERXHeaderMobileView()}
      {isPatientDetailsPopupOpen && (
        <C2CCustomPopup
          openPopup={isPatientDetailsPopupOpen}
          popupHeading="Patient Details"
          dialogClassName="patient-details-popup-view"
          handleClosePopup={handleClosePopup}
        >
          <PDView {...props} />
        </C2CCustomPopup>
      )}
      {isPopupOpen && (
        <C2CCustomPopup
          openPopup={isPopupOpen}
          popupHeading="Prescription Settings"
          dialogClassName="add-recored-details"
          handleClosePopup={handleSettingClosePopup}
        >
          {displayAddSetting()}
        </C2CCustomPopup>
      )}
      {savePrescriptionTemplate && (
        <C2CCustomPopup
          openPopup={savePrescriptionTemplate}
          popupHeading={<span>Save Template {renderPopover()}</span>}
          dialogClassName="erx-save-template-popup"
          handleClosePopup={handleTemplateCancel}
        >
          {displaySaveTemplate()}
        </C2CCustomPopup>
      )}
    </div>
  );
};
export default ERXViewHeader;
